import {getEnv} from '../../common/env/env';
import {LineBannerDto} from '../../common/shared/api/gateway/LineBannerDto.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {EventLog, ItemType, LineBannerItem} from '../generated/types';

export function createLineBannerItem({
  uid,
  scheme,
  title,
  sub_title,
  bg_color,
  right_image,
}: LineBannerDto): LineBannerItem {
  const eventLog: EventLog = {
    eventMeta: {
      id: scheme,
      type: 'scheme',
      provider: '서비스',
    },
    customProps: {
      banner_uid: String(uid),
      landing_path: scheme,
    },
    click: {
      copy: title,
    },
  };
  return {
    id: String(uid),
    type: ItemType.LineBanner,
    scheme,
    title,
    bgColor: bg_color,
    subTitle: sub_title,
    rightImage: right_image
      ? right_image.startsWith('http')
        ? right_image
        : getKageUrl({
            kageUrlPrefix: getEnv().kageUrlPrefix,
            kageId: right_image,
            resolution: 'th3',
          })
      : undefined,
    eventLog,
  };
}
